const COMPONENT_NAME = "FeatureHighlightCard";
const VIEW_NAME_CALLOUT = "callout";
const VIEW_NAME_FEATURES = "features";
const VIEW_NAME_SKELETON = "skeleton";
export {
  COMPONENT_NAME,
  VIEW_NAME_CALLOUT,
  VIEW_NAME_FEATURES,
  VIEW_NAME_SKELETON
};
